"use client";

import React from "react";
import { Github, Mail } from "lucide-react";

const DEFAULT_LINKS = [
  { label: "About", href: "/about" },
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms of Service", href: "/terms" },
 
  { label: "Contact", href: "/contact" },
];

export default function Footer({
  brand = "Rec-Builder",
  links = DEFAULT_LINKS,
  githubUrl = "#",
  email = "hello@example.com",
}) {
  return (
    <footer className="bg-white border-t border-gray-200">
      {/* Accent bar */}
      <div className="h-1 w-full bg-gradient-to-r from-teal-600 to-orange-600" />

      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        {/* Top row */}
        <div className="py-8 md:py-10 grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          {/* Brand */}
          <div className="flex items-center justify-center md:justify-start">
            <a href="/" className="inline-flex items-center gap-2">
              <span className="text-2xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-teal-600 to-orange-600">
                {brand}
              </span>
            </a>
          </div>

          {/* Privacy/About nav */}
          <nav className="flex justify-center">
            <ul className="flex flex-wrap items-center gap-x-4 gap-y-2">
              {links.map(({ label, href }) => (
                <li key={label}>
                  <a
                    href={href}
                    className="text-sm font-medium text-gray-700 hover:text-teal-600 transition"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Social + CTA */}
          <div className="flex items-center justify-center md:justify-end gap-4">
         
            <a
              href="/subscribe"
              className="hidden sm:inline-flex items-center rounded-full px-4 py-2 text-sm font-semibold text-white bg-gradient-to-r from-teal-600 to-orange-600 hover:from-teal-700 hover:to-orange-700 shadow-md transition"
            >
              Get Started
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px w-full bg-gray-200" />

        {/* Bottom row */}
        <div className="py-6 flex flex-col-reverse md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} {brand}. All rights reserved.
          </p>

          <div className="flex items-center gap-4">
            <a
              href="/about"
              className="text-xs text-gray-500 hover:text-teal-600 transition"
            >
              About
            </a>
            <a
              href="/privacy"
              className="text-xs text-gray-500 hover:text-teal-600 transition"
            >
              Privacy
            </a>
            <a
              href="/terms"
              className="text-xs text-gray-500 hover:text-teal-600 transition"
            >
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
